import React from 'react'
import { useTranslation } from 'react-i18next'
import { TaskDetailsIcon } from '../../icons'
import './DetailsToggle.scss'
import { WithTooltip } from '@/src/renderer/components/ui/tooltip'

export interface DetailsToggleProps {
  /** Ob die Aufgaben-Details gerade offen stehen — der Knopf rastet dann ein. */
  open: boolean
  onToggle: () => void
  className?: string
}

/**
 * **Der Öffnen-Knopf der Aufgaben-Details**, im Projektkopf rechts neben
 * dem Paar Liste/Stapel — mit Abstand dazwischen.
 *
 * Ein EIGENER Knopf und kein drittes Segment in der bestehenden Gruppe
 * (CONTEXT.md, Aufgaben-Details): Liste und Stapel schalten den **Fenster-Modus**
 * und federn zurück, sie tragen keinen Zustand. Die Aufgaben-Details sind an oder
 * aus. Eine Gruppe, in der zwei Knöpfe zurückfedern und einer einrastet, lernt
 * niemand.
 *
 * Das Einrasten steht deshalb auch in der Bedienhilfe: `aria-pressed` sagt den
 * Zustand, der Name sagt, was der nächste Klick tut.
 *
 * @example
 * <DetailsToggle open={detailsOpen} onToggle={toggleDetails} />
 */
export const DetailsToggle: React.FC<DetailsToggleProps> = ({ open, onToggle, className }) => {
  const { t } = useTranslation()
  const label = t(open ? 'taskDetails.close' : 'taskDetails.open')

  return (
    // ⌘I schaltet die Details auch per Taste (#257).
    <WithTooltip content={label} shortcut={{ kind: 'character', text: 'I', mod: true }}>
      <button
        type="button"
        className={[
          'details-toggle',
          open && 'details-toggle--open',
          className,
        ].filter(Boolean).join(' ')}
        aria-pressed={open}
        aria-label={label}
        onClick={onToggle}
      >
        <TaskDetailsIcon size={16} />
      </button>
    </WithTooltip>
  )
}
